import { useEffect } from 'react';
import { useInboxCount } from '@/hooks/ui/useInboxCount';

type BadgingNavigator = Navigator & {
  setAppBadge?: (n?: number) => Promise<void>;
  clearAppBadge?: () => Promise<void>;
};

/**
 * Mirror the inbox count onto the installed-PWA app icon badge
 * (dock / taskbar / home-screen) using the Badging API.
 *
 * No-op on browsers without `navigator.setAppBadge` (Firefox, older Safari).
 * Mount once in the app shell.
 */
export function useAppBadge(): void {
  const count = useInboxCount();

  useEffect(() => {
    const nav = navigator as BadgingNavigator;
    if (!nav.setAppBadge) return;

    if (count > 0) {
      void nav.setAppBadge(count);
    } else {
      void nav.clearAppBadge?.();
    }

    return () => {
      void nav.clearAppBadge?.();
    };
  }, [count]);
}
